import type * as React from 'react';
import { graphql } from 'react-apollo';

import gql from 'graphql-tag';
import { compose } from 'recompose';

import type { ReplaceCustomContent } from '../types/CustomLabels';
import type {
  CustomLabelsV2,
  CustomLabelsV2ByCourseBranchQuery,
  CustomLabelsV2ByCourseBranchQueryVariables,
} from './__generated__/CustomLabelsV2';
import withCustomLabelsMapping from './withCustomLabelsMapping';

type OuterProps = {
  courseId: string;
  courseBranchId: string;
};

type InnerProps = OuterProps & {
  customLabelsV2?: CustomLabelsV2;
  replaceCustomContent: ReplaceCustomContent;
};

/* eslint-disable graphql/template-strings */
const CustomLabelsQuery = gql`
  query CustomLabelsByBranchQuery($id: String!) {
    CustomLabelsV2 @naptime {
      byCourseBranch(id: $id) {
        elements {
          id
          moduleNames
          namings {
            courseraCourse
            courseraWeek
          }
        }
      }
    }
  }
`;
/* eslint-enable graphql/template-strings */

export default <PropsFromCaller extends OuterProps>(Component: React.ComponentType<PropsFromCaller & InnerProps>) =>
  compose<InnerProps & PropsFromCaller, PropsFromCaller>(
    graphql<
      PropsFromCaller & InnerProps,
      CustomLabelsV2ByCourseBranchQuery,
      CustomLabelsV2ByCourseBranchQueryVariables,
      InnerProps
    >(CustomLabelsQuery, {
      options: ({ courseBranchId }) => ({
        variables: {
          id: courseBranchId,
        },
      }),
      props: ({ data, ownProps }) => {
        const customLabelsV2 = data?.CustomLabelsV2?.byCourseBranch?.elements?.[0];

        return {
          ...ownProps,
          customLabelsV2,
        };
      },
    }),
    withCustomLabelsMapping
  )(Component);
